//include 10
jQuery(function(){

    window.ppComponents = window.ppComponents || {};
    window.ppComponents.select2months = window.ppComponents.select2months || {};

    var monthShortcuts = {
        'januar': window.ppt.translate('date.january.short','Jan'),
        'februar': window.ppt.translate('date.february.short','Feb'),
        'march': window.ppt.translate('date.march.short','Mar'),
        'april': window.ppt.translate('date.april.short','Apr'),
        'may': window.ppt.translate('date.may.short','Mai'),
        'june': window.ppt.translate('date.june.short','Jun'),
        'july': window.ppt.translate('date.july.short','Jul'),
        'august': window.ppt.translate('date.august.short','Aug'),
        'september': window.ppt.translate('date.september.short','Sep'),
        'october': window.ppt.translate('date.october.short','Okt'),
        'november': window.ppt.translate('date.november.short','Nov'),
        'dezember': window.ppt.translate('date.dezember.short','Dez')
    };

    var privateFunctions = {
        updateSelection(data, adapter) {
            adapter.clear();

            if (data.length === 0) {
                return;
            }

            var $selections = [];

            for (var d = 0; d < data.length; d++) {
                var selection = data[d];

                var $selection = adapter.selectionContainer();
                var formatted = adapter.display(selection, $selection);

                $selection.append(formatted);
                $selection.prop('title', selection.title || selection.text);

                $selection.data('data', selection);

                $selections.push($selection);
            }

            var $rendered = adapter.$selection.find('.select2-selection__rendered');

            Utils.appendMany($rendered, $selections);
        }
    }

    //********************************************************************************** */
    //********************************************************************************** */

    $.fn.select2.amd.define('select2/selection/customSelection', ['select2/selection/multiple', 'select2/utils'],
        function (Multiple, Utils) {
            function CustomMultiple($element, options) {
                CustomMultiple.__super__.constructor.call(this, $element, options);
            }
            Utils.Extend(CustomMultiple, Multiple);

            CustomMultiple.prototype.selectionContainer = function () {
                var $container = $(
                    '<li class="select2-selection__choice months">' +
                    '</li>'
                );
                return $container;
            };

            //small helper function
            var isInDataArray = function (data, id) {
                var isInData = false;
                $.each(data, function (i, d) {
                    if (d.id == id) {
                        isInData = true;
                        return false;
                    }
                });
                return isInData;
            }

            CustomMultiple.prototype.createPlaceholder = function () {
                var placeholder = this.$element.data("placeholder") || this.$element.attr("placeholder");
                var $placeholder = `<span class="select2-selection__placeholder months" title="${placeholder}">${placeholder}</span>`;
                this.$selection.closest('.select2-container').addClass("no-padding");
                return $placeholder;
            };

            CustomMultiple.prototype.createCloseButton = function () {
                var $closeButton = $('<a href="#" class="close-button">&times;</a>');
                var self = this;
                $closeButton.on("click",function(e){
                    e.preventDefault();
                    self.clear();
                    self.$element.val("").change();
                    $closeButton.hide();
                    self.$selection.find('.select2-selection__rendered').append(self.createPlaceholder());
                });
                return $closeButton;
            };

            CustomMultiple.prototype.update = function (data) {
                this.clear();

                var $rendered = this.$selection.find('.select2-selection__rendered');
                var $container = this.$selection.closest('.select2-container');
                $container.removeClass("no-padding");
                if (data.length === 0) {
                    $rendered.append(this.createPlaceholder());
                    $container.find(".close-button").hide();
                    return;
                }

                if($container.find(".close-button").length == 0){
                    $container.append(this.createCloseButton());
                }
                $container.find(".close-button").show();


                var $selections = [];

                //*-----------------------------
                var included = [{
                        id: 'januar',
                        included: false
                    },
                    {
                        id: 'februar',
                        included: false
                    },
                    {
                        id: 'march',
                        included: false
                    },
                    {
                        id: 'april',
                        included: false
                    },
                    {
                        id: 'may',
                        included: false
                    },
                    {
                        id: 'june',
                        included: false
                    },
                    {
                        id: 'july',
                        included: false
                    },
                    {
                        id: 'august',
                        included: false
                    },
                    {
                        id: 'september',
                        included: false
                    },
                    {
                        id: 'october',
                        included: false
                    },
                    {
                        id: 'november',
                        included: false
                    },
                    {
                        id: 'dezember',
                        included: false
                    }
                ];

                var results = [];
                var selections = [];
                for (var m = 0; m < included.length; m++) {
                    if (included[m].included)
                        continue;
                    if (!isInDataArray(data, included[m].id)) {
                        continue;
                    }
                    var result = monthShortcuts[included[m].id];
                    included[m].included = true;

                    selections.push({
                        id:included[m].id,
                        text:included[m].id
                    });

                    var monthToIndex = m;
                    for (var i = m; i < included.length; i++) {
                        if (!isInDataArray(data, included[i].id))
                            break;
                        monthToIndex = i;
                    }
                    if (monthToIndex > (m + 1)) {
                        for (var i = m + 1; i <= monthToIndex; i++) {
                            included[i].included = true;
                            selections.push({
                                id:included[i].id,
                                text:included[i].id
                            });
                        }
                        result += "-" + monthShortcuts[included[monthToIndex].id];
                    }
                    results.push(result);                   
                }

                var displayString = results.join(", ");

                var $selection = this.selectionContainer();
                var selection = {
                    text: displayString,
                    id: displayString
                };
                var formatted = this.display(selection, $selection);
                $selection.append(formatted);
                $selection.data('data', selections);
                $selections.push($selection);
                //----------------------------- */

                Utils.appendMany($rendered, $selections);
            };

            return CustomMultiple;
        });

    var customSelect = $.fn.select2.amd.require('select2/selection/customSelection');
    //********************************************************************************** */
    /********************************************************************************** */

    window.ppComponents.select2months.initialize = function (elements) {
        elements.each(function () {
            var placeholdertext = $(this).attr('placeholder');
            var cssClass = $(this).data('dropdown-css-class') || "";
            var allowClear = $(this).data('allow-clear') || false;

            var $this = $(this);

            if (!placeholdertext) {
                var emptyOption = $(this).find("option[value='']");
                if (emptyOption.length > 0) {
                    placeholdertext = emptyOption.text();
                } else {
                    placeholdertext = "";
                }
            }

            var placeholder = {
                id: "",
                text: placeholdertext
            };

            $this.select2({
                placeholder: placeholder,
                selectOnClose: false,
                selectionAdapter: customSelect,
                minimumResultsForSearch: Infinity, // preventing the searchbox
                dropdownCssClass: cssClass
            });

            //var $this = $(this);

            /*var enableResizableText = $this.is("[data-resizable-text]");
            $this.off("select2:select").on("select2:select", function (e) {
                if (enableResizableText) {
                    var selectionWrapper = $this.parent().find(".selection");
                    var rendered = selectionWrapper.find(".select2-selection__rendered");
                    rendered.css("font-size", "");
                    var parentWidth = selectionWrapper.width(),
                        parentHeight = selectionWrapper.height(),
                        width = rendered.width(),
                        height = rendered.height();
                    var computedStyle = window.getComputedStyle($this[0]);
                    var fontsize = computedStyle.getPropertyValue('font-size');
                    fontsize = parseFloat(fontsize);
                    while (width > (parentWidth - 25) || height > parentHeight) {
                        fontsize *= 0.95;
                        rendered.css("font-size", fontsize + "px");
                        width = rendered.width();
                        height = rendered.height();
                    }
                }
            });*/
        });
    };

    window.ppComponents.select2months.initialize($('.month-select'));

    if (!window.pixelpoint.isMobile.any()) {
        $('body').on("select2:open", ".select2.hoversupport", function (e) {
            $(this).parents('.menu-level-1,.supersection').removeClass('hover').addClass('hover');
        });
        $('body').on("select2:close", ".select2.hoversupport", function (e) {
            var that = $(this);
            setTimeout(function (e) {
                $(that).parents('.menu-level-1,.supersection').removeClass('hover');
            }, 100);
        });
    }

    $(window).on("orientationchange", function () {
        $(".month-select.select2-hidden-accessible").each(function () {
            var self = $(this);
            self.select2("destroy");
            setTimeout(function () {
                window.ppComponents.select2months.initialize(self);
            }, 50);
        });
    });

});